// extracted by mini-css-extract-plugin
export default {"results":"DiceRollResultView_results__a8okQ","standard":"DiceRollResultView_standard__WYcCM","success":"DiceRollResultView_success__ywHq-","luck":"DiceRollResultView_luck__jioHt"};